module.exports = ["Soyabean","Cowpea","Maize","Rice","Vegetables","Yam","Cassava","Sorghum","Onion","Tomato","Pepper","Groundnut"]


//////////////////
// WEBPACK FOOTER
// ./src/views/Farmers/Crops.json
// module id = 2150
// module chunks = 0